import { ReactNode } from 'react'

import styles from './store-intro.module.css'
import sharedStyles from '../../landing-feature-store-page.module.css'
import { StoreCtaButton } from '../cta-button'

export interface StoreIntroProps {
  title: string
  introText: ReactNode
  slug: string
}
export const StoreIntro = ({ introText, title, slug }: StoreIntroProps) => (
  <section className={styles.introSectionWrapper}>
    <h2 className={sharedStyles.heading}>{title}</h2>
    <div className={styles.storeIntroText}>{introText}</div>
    <div className={styles.introButton}>
      <StoreCtaButton slug={slug} trackEventTitle={'Intro section'} />
    </div>
  </section>
)
